



import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
})
export default class Redirect extends Vue {

  private created() {
    this.$router.push(this.$route.query);
  }
}

